<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
  <div class="row d-flex flex-row">
    <div class="col-sm-12 align-items-center">

      <div class="auth-box">

        <div class="logo-above-auth-box logo-tenant-as-background"></div>

         <!-- content -->
         <div class="auth-box-content-wrapper">

          <h2 class="auth-box_title">{{ 'usermenu.changecustomer' | translate }}</h2>

          <div class="customer-search">
            <!--<form [formGroup]="searchForm" (submit)="onSubmit()"></form>-->
              <input  #search
                    type="search"
                    name="search"
                    class="form-control"
                    placeholder="{{ 'header.search' | translate }}..."
                    autocomplete="off"
                    [formControl]="searchField"
                    />

                <i *ngIf="!searchField.value || searchField.value.length < 1" class="fa fa-search icon-hide-onmobile"></i>
                <i style="cursor: pointer" *ngIf="searchField.value && searchField.value.length > 0" class="fa fa-close icon-hide-onmobile" (click)="resetSearch()"></i>

          </div>

          <div class="customer-list list-group" *ngIf="customers?.length" infinite-scroll infiniteScrollDistance="1" infiniteScrollThrottle="300" (scrolled)="expand()">
            <div style="cursor: pointer; user-select: none;" *ngFor="let customer of customers" class="customer-item list-group-item list-group-item-action" (click)="selectCustomer(customer)">

              <h3 *ngIf="customer && customer.name">
                {{ customer.name }}
                
              </h3>

              <p class="street" *ngIf="customer && customer.address && customer.address.addressLine1">
                {{ customer.address.addressLine1 }}<span *ngIf="customer && customer.address && customer.address.city">, {{ customer.address.city }}</span>
              </p>

              <p class="customercode" *ngIf="customer && customer.code && customer.address">
                  <span *ngIf="customer.address.type.toLowerCase() === 'delivery'">{{ 'checkout.delivery-address' | translate }}</span>
                  <span *ngIf="customer.address.type.toLowerCase() === 'invoice'">{{ 'checkout.invoice-address' | translate }}</span>: {{ customer.address.code }}
              </p>

              <span class="badge badge-pill badge-success" *ngIf="customer?.openCarts">
                {{ customer?.openCarts }}
              </span>

            </div>
          </div>

          <p *ngIf="!loading && !(customers?.length)">No results</p>

          <app-loader *ngIf="loading" enabled="true" type="round"></app-loader>

        </div>
      </div>
    </div>
  </div>
